import * as yup from 'yup'

const schema = yup.object().shape({
  planWhat: yup.string().required(),
  planWhy: yup.string().required(),
  planWhere: yup.string().required(),
  planHow: yup.string().required(),
  planHowMuch: yup.string().required(),
  planResources: yup.string().required(),
  planWho: yup.string().required(),
  planWhen: yup.date().required().typeError('Precisa ser uma data válida'),
  implementEvidence: yup.string().required(),
  implementRealization: yup.date().nullable(),
  decisionObservations: yup.string(),
  decisionExpectedDate: yup.date().nullable(),
  decisionFinishedDate: yup.date().nullable(),
})

export default schema
